const ACTION_PREFIX = "[Deposit]";
export const CORE_DEPOSIT_ACTION_TYPE = {
	completed: `${ACTION_PREFIX} Completed`,
};
